// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"94c70bd9","441":"2ebffa27"}[chunkId] + ".chunk.js";
};